import { STATES_DATA, statesWithInsurance } from './states';

const backendURL = window.localStorage['backend_url'] || 'https://title.closing.works/api/';

export const fetchStates = async () => {
  return { data: STATES_DATA };
};

function fromBackendDecimal(val) {
  if (!val) return 0;

  return parseFloat(val.replaceAll('$', '').replaceAll(',', '')) || 0;
}

function sum(xs) {
  return xs.reduce((acc, x) => acc + x, 0);
}

function normalizeDollarField(value) {
  return Number(value.replace(/[^0-9.-]+/g, '')) || 0;
}

function normalizeFormBoolean(value) {
  if (value === 'true') return true;
  if (value === 'false') return false;
  return null;
}

function prepareFormData(values) {
  return {
    country: 'US', // xD
    state: values.state,
    county: values.county,
    municipality: values.municipality,
    financing_type: values.type,
    title_insurance_type: statesWithInsurance.includes(values.state) ? values.policy : null,
    purchase_price: normalizeDollarField(values.purchasePrice),
    loan_amount: normalizeDollarField(values.loanAmount),
    land_type: values.land_type,
    is_primary_residence: normalizeFormBoolean(values.is_primary_residence),
    is_first_time_homebuyer: normalizeFormBoolean(values.is_first_time_homebuyer),
  };
}

export const getCostEstimates = async (values) => {
  const payload = prepareFormData(values);

  const resp = await fetch(new URL('financials/fee_calculator', backendURL), {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!resp.ok) {
    throw new Error(`Unable to fetch: ${resp.status} ${resp.statusText} ${await resp.text()}`);
  }

  const data = await resp.json();

  const costs = data.fees.map((v) => ({
    label: v.title,
    buyer_cost: v.buyer_fee,
    seller_cost: v.seller_fee,
    refinance_cost: v.refinance_fee,
  }));

  return {
    data: {
      total_cost: data.totals.total,
      buyer_total_cost: data.totals.buyer,
      seller_total_cost: data.totals.seller,
      costs,
    },
  };
};

export const emailEstimateCost = async (values, email, salesperson) => {
  const resp = await fetch(new URL('financials/fee_calculator/submit', backendURL), {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({
      ...prepareFormData(values),
      customer_email: email,
      salesperson_email: salesperson,
    }),
  });

  if (!resp.ok) {
    throw new Error(`Unable to fetch: ${resp.status} ${resp.statusText} ${await resp.text()}`);
  }
};
